import styles from './DebugBanner.module.scss';

export function DebugBanner() {
    return (
        <div className={styles.banner} data-testid="eb-web-debug-banner">
            eb-web
        </div>
    );
}
